<!--
  -  Copyright (c) Qwoach LLC 2023. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 1/1/2023
  -->

<template>
	<input ref="localInput"
		   class="qw-file-picker-root"
		   v-if="!isFileLoading"
		   type="file"
		   @change="onFilePicked"
		   :accept="filter.join(',')">
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import {humanFileSize} from "@/utils/helpers";

export default {
	name: "LocalFilePicker",
	extends: BaseComponent,

	props: {
		filter: {Array, default: () => []},
		filterNames: {Array, default: () => []},
		sizeLimit: Number,
		loadFileOnSelect:{type: Boolean, default: true},
	},

	data() {
		return {
			isFileLoading: false,
			fileManager: null
		}
	},

	mounted(){
		this.fileManager = this.$fileUploader.fileManager
	},


	methods: {
		pickFile(){
			this.$refs.localInput.click()
		},

		onFilePicked(ev) {
			if(this.isFileLoading){
				return;
			}
			if(!ev.target){
				return
			}
			let fileInput = ev.target
			let file = fileInput.files[0];
			ev.target.value = null
			if(!file){
				return;
			}
			let qwoachFile = this.fileManager.fileToQwoachFile(file)
			if(!this.fileNameIsAllowed(file.name)){
				let filters = this.filterNames.length > 0 ? this.filterNames : this.filter
				console.log("filters = ", filters)
				this.toastWarn(`Only ${filters.join(", ")} files are allowed`)
				return
			}
			if(this.sizeLimit > 0 && file.size > this.sizeLimit){
				this.toastWarn("File is too big (" + humanFileSize(this.sizeLimit) + " max)")
				return
			}
			if(this.loadFileOnSelect){
				this.setFileLoading(true)
				const reader = new FileReader();

				reader.onload = e => {
					// fileInput.value = null
					this.setFileLoading(false)
					this.$emit("fileSelected", qwoachFile, e.target.result);
				}
				reader.onerror = e => {
					fileInput.value = null
					this.setFileLoading(false)
					console.error(e)
				}
				reader.readAsDataURL(file);
			} else {
				this.$emit("fileSelected", qwoachFile);
			}
		},

		setFileLoading(isLoading){
			let isChanged = isLoading !== this.isFileLoading
			this.isFileLoading = isLoading
			if(isChanged){
				this.$emit("loadingChanged", this.isFileLoading)
			}

		},

		fileNameIsAllowed(fileName){
			console.log("fileNameIsAllowed: ", fileName)
			if(this.filter.length === 0){
				return true
			}
			for(let filter of this.filter){
				if(fileName.toLowerCase().endsWith(filter)){
					console.log("fileNameIsAllowed: ends with ", filter)
					return true
				}
			}
			return false
		}
	},
}
</script>

<style lang="scss">

.qw-file-picker-root{
	//&input {
	//	position: absolute;
	//	top: 0;
	//	left: 0;
	//	z-index: -1;
	//	opacity: 0;
		visibility: hidden;
	//}
}

</style>
